var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.9206V9.74603C20 9.57847 19.9639 9.4132 19.8944 9.26333C19.825 9.11345 19.7242 8.98308 19.6 8.88254L12.6 3.21587C12.4269 3.07575 12.2164 3 12 3C11.7836 3 11.5731 3.07575 11.4 3.21587L4.4 8.88254C4.2758 8.98308 4.175 9.11345 4.10557 9.26333C4.03614 9.4132 4 9.57847 4 9.74603V18.9206C4 19.2069 4.10536 19.4814 4.29289 19.6839C4.48043 19.8863 4.73478 20 5 20H9C9.26522 20 9.51957 19.8863 9.70711 19.6839C9.89464 19.4814 10 19.2069 10 18.9206V15.6825C10 15.3963 10.1054 15.1217 10.2929 14.9193C10.4804 14.7169 10.7348 14.6032 11 14.6032H13C13.2652 14.6032 13.5196 14.7169 13.7071 14.9193C13.8946 15.1217 14 15.3963 14 15.6825V18.9206C14 19.2069 14.1054 19.4814 14.2929 19.6839C14.4804 19.8863 14.7348 20 15 20H19C19.2652 20 19.5196 19.8863 19.7071 19.6839C19.8946 19.4814 20 19.2069 20 18.9206Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.017f19e9c4aa4a4eff6f7e27739844b9.svg";
export { ForwardRef as ReactComponent };